import React from 'react';
import { useNavigate } from 'react-router-dom';

import Card from './Card';
import styled from 'styled-components';

const CountryCard = ({country}) => {
    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate(`/${country.countryInfo.iso3}`);
    };

    return <Card>
        <StyledCountryCard onClick={handleRedirect}>
            <div className='flag'>
                <img src={country.countryInfo.flag} alt="" />
                <h3>{country.country}</h3>
            </div>
        </StyledCountryCard>
    </Card>;
};

const StyledCountryCard = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;

    .flag {
        display: grid;
        grid-template-rows: 180px 1fr;
        height: 100%;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
            border-radius: 8px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        h3 {
            font-size: 1.1rem;
            font-weight: 600;
            text-align: center;
            margin-top: 1rem;
            color: ${({ theme }) => theme.text};
            transition: color 0.3s ease;
        }
    }

    &:hover {
        .flag img {
            transform: scale(1.05);
        }
        
        .flag h3 {
            color: ${({ theme }) => theme.primary};
        }
    }
`;

export default CountryCard;
